import {
  ManfrediteOfferFilterCreateRequest,
  ManfrediteOfferFilterResponse
} from '@asgard/api-common';
import { MultilingualLanguages } from '@asgard/common-dto';
import { ManfrediteOfferAlert } from 'model/model-manfredite-offer-alert';
import * as fetch from 'utils/fetch';
import { getAuthHeader } from 'utils/headers';
import { API_BASE_URL, NEXT_API_URL } from './service-offer-alert.constants';
import {
  normalizeToManfrediteOfferAlert,
  normalizeToManfrediteOfferAlerts
} from './service-offer-alert.normalizer';

const OfferAlertService = {
  getAll: async (
    lang: MultilingualLanguages,
    token?: string
  ): Promise<ManfrediteOfferAlert[]> => {
    const baseUrl = token ? API_BASE_URL : NEXT_API_URL;

    const res = await fetch.get<ManfrediteOfferFilterResponse[]>(
      `${baseUrl}?lang=${lang}`,
      getAuthHeader(token)
    );

    return normalizeToManfrediteOfferAlerts(res, lang);
  },

  save: async (
    lang: MultilingualLanguages,
    offerFilter: ManfrediteOfferFilterCreateRequest,
    token?: string
  ): Promise<ManfrediteOfferAlert> => {
    const baseUrl = token ? API_BASE_URL : NEXT_API_URL;

    const res = await fetch.post<
      ManfrediteOfferFilterCreateRequest,
      ManfrediteOfferFilterResponse
    >(`${baseUrl}?lang=${lang}`, offerFilter, getAuthHeader(token));

    return normalizeToManfrediteOfferAlert(res, lang);
  },

  remove: async (id: string, token?: string): Promise<void> => {
    const baseUrl = token ? API_BASE_URL : NEXT_API_URL;

    return fetch._delete(`${baseUrl}/${id}`, getAuthHeader(token));
  }
};

export default OfferAlertService;
